@if (callingUser.type) {
<div class="audio_receiver">
  <div class="audio_rec_view">
    <div class="">
      @if (!callingUser.user_icon) {
      <empty-uname
        [userName]="callingUser.firstName"
        [detailHeadProfile]="true"
      >
      </empty-uname>
      } @if (callingUser.user_icon) {
      <img [src]="profileUrl + callingUser.user_icon" class="is-pulled-left" />
      }
    </div>
    <h2>{{ callingUser.firstName + " " + callingUser.lastName }}</h2>
    <p class="is-small">Ringing...</p>
    <a class="audio_btn" (click)="callDeactivated()"
      ><i class="fa fa-phone rotate-img"></i
    ></a>
    <a class="audio_btn" (click)="callActivated()"
      ><i class="fa fa-phone"></i
    ></a>
  </div>
</div>
}

<!-- <div class="audio_receiver user_minimiz">
<div class="audio_rec_view">
  <h2>John <span id="time" class="text-primary">{{display }}</span></h2>
  <div class="">
    <div class="empty-profile-icon">J</div>
  </div>
  <a class="option_btn" ><i class="fa fa-microphone" aria-hidden="true"></i></a>
  <a class="option_btn" ><i class="fa fa-stop"></i></a>
  <a class="audio_btn" (click)="callDeactivated()"><i class="fa fa-phone rotate-img"></i></a>
</div>
</div> -->
